import React from 'react'
import { Card } from '../atoms/Card'
import { StatusMetric } from '../molecules/StatusMetric'

interface SystemStatusSectionProps {
  activeFeedbackCount?: number
  totalApplicationsCount?: number
  pendingFeedbackCount?: number
  className?: string
  'data-testid'?: string
}

export const SystemStatusSection: React.FC<SystemStatusSectionProps> = ({
  activeFeedbackCount = 0,
  totalApplicationsCount = 0,
  pendingFeedbackCount = 0,
  className = '',
  'data-testid': testId = 'status-card',
}) => {
  return (
    <Card className={`mb-8 ${className}`} data-testid={testId}>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatusMetric
          value={activeFeedbackCount}
          label="Active Feedback"
          variant="success"
        />
        <StatusMetric
          value={totalApplicationsCount}
          label="Applications"
          variant="info"
        />
        <StatusMetric
          value={pendingFeedbackCount}
          label="Pending Review"
          variant="warning"
        />
      </div>
    </Card>
  )
} 